import { useDispatch } from 'react-redux'
import { getRecentlyOpened, getRecentlyOpenedEntities, putRecentlyOpenedEntity } from '../recentlyOpened/state/actions'
import { APIResponse, RecentlyOpenedEntity, RecentlyOpenedEntityType } from '@cbgms/api'
import useQuery, { useQueryClient } from '@cbgms/base/http/use-query'
import { useGetCurrentShopID } from 'app/shops/hooks/useGetCurrentShopID'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'

const RECENTLY_OPENED_ENTITIES = 'RECENTLY_OPENED_ENTITIES'

export const useFetchRecentlyOpenedEntities = (isEnabled: boolean) => {
  const dispatch = useDispatch()
  const currentShopID = useGetCurrentShopID()
  const isPortal = useIsPortal()
  const result = useQuery(
    [RECENTLY_OPENED_ENTITIES, currentShopID, isEnabled],
    async () => {
      if (!isEnabled) {
        return new Promise<APIResponse<RecentlyOpenedEntity[]>>(resolve => resolve({ Data: [] }))
      }
      if (isPortal) {
        return dispatch(getRecentlyOpened(10, RecentlyOpenedEntityType.Vehicle))
      }
      return dispatch(getRecentlyOpenedEntities(10))
    },
    { refetchOnWindowFocus: false }
  )
  return result
}

export const usePutNewRecentlyOpenedEntities = () => {
  const dispatch = useDispatch()
  const qc = useQueryClient()

  return async (entityType: RecentlyOpenedEntityType, uuid: string) => {
    await dispatch(putRecentlyOpenedEntity(entityType, uuid))
    qc.invalidateQueries([RECENTLY_OPENED_ENTITIES])
  }
}
